import { install } from '@attendu/email-components';
import '@attendu/email-components/dist/style.css';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(install);
});
